export default {
  contentTable: {},
  contentFather: {},
  content: {},
  closeButton: {
    height: '5%',
    width: '3%',
    top: '15px',
    float: 'right',
    position: 'absolute',
    zIndex: '600',
    background: 'none',
    cursor: 'pointer',
    color: data => data.mainColor,
    border: '0',
    fontSize: '20px',
    right: '15px',
    '&:lang(ar)':{
      left:'15px',
      right:'auto',
      float:'left'
    }
  },
  modalStyle: {
    position: 'fixed',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    padding: '50px',
    background: 'rgba(0,0,0,0.5)',
    zIndex: '600',
    overflow: 'auto',
    '& $contentTable': {
      width:'100%',
      height:'100%',
      display:'flex',
      flexDirection:'column',
      justifyContent:'center',
      '& $contentFather': {
        textAlign: 'center',
      },
      '& $content': {
        maxWidth: '1181px',
        margin: '0 auto',
        background: '#fff',
        position: 'relative'
      }
    },
    '&#calendarModal':{
      display:'flex',
      alignItems:'center',
      justifyContent:'center',
      zIndex:'500',
      '@media(min-width:801px)':{
        zIndex:'502',
      }
    }
  },
  resumeModalStyle: {
    position: 'fixed',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
    padding: '50px',
    background: 'rgba(0,0,0,0.5)',
    zIndex: '600',
    overflow: 'auto'
  },

  hotelModalStyle: {
    backgroundColor:'#fff',
    padding:0,
    '& $contentTable': {
      display:'block'
    },
    '& $contentFather':{
      textAlign:'left !important',
      height:'100%'
    }
  }
};
